import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

const lineV = {
  hidden: { y: "110%" },
  show: ({ i, d }) => ({ y: "0%", transition: { duration: 1.1, ease: EASE, delay: d + i * 0.1 } }),
};

export const MaskLines = ({ lines, className = "", lineClassName = "", onLoad = false, delay = 0, testId }) => {
  const trigger = onLoad
    ? { initial: "hidden", animate: "show" }
    : { initial: "hidden", whileInView: "show", viewport: { once: true, amount: 0.15 } };
  return (
    <motion.div {...trigger} className={className} data-testid={testId}>
      {lines.map((l, i) => (
        <span key={i} className="block overflow-hidden pb-[0.06em]">
          <motion.span custom={{ i, d: delay }} variants={lineV} className={`block ${lineClassName}`}>
            {l}
          </motion.span>
        </span>
      ))}
    </motion.div>
  );
};

export const Reveal = ({ children, className = "", delay = 0, y = 32 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.9, ease: EASE, delay }}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children, className = "" }) => (
  <p className={`font-mono text-xs uppercase tracking-[0.25em] text-amber-400 ${className}`}>{children}</p>
);
